import { Dropdown, Space, Tooltip } from "antd";
import React from "react";
import { NavLink } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import {
  BinocularsLight,
  EditIcon,
  LockIcon,
  MoreIcon,
  NewSparkleSmallIcon,
  RecycleBin,
  ShareIcon,
} from "../../../constants/svg";
import { formatDate, hasAccess } from "../../../utils/helper";
import { FaStar } from "react-icons/fa";

export const getColumns = (
  setShowModal,
  setSurveyIDForDelete,
  handleOpenEditForm,
  setSurveyShareData,
  handleSetSelectedData,
) => {
  return [
    {
      title: "Survey Name",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
      sortDirections: ["descend", "ascend", "descend"],
      render: (text, record) => (
        <>
          <NavLink
            to={`/surveys/details/${record.id}`}
            className={"black imageTableWrapper"}
          >
            <Space size={10}>
              <img
                src={record.image}
                alt={record.title}
                className="eventDetailImage"
              />
              {record.lock && (
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: "1",
                        label: (
                          <>
                            <div className="adminRoleBox lockBox">
                              <h6>
                                <span>
                                  <NewSparkleSmallIcon />
                                </span>{" "}
                                Posted by Salon Symphony
                              </h6>
                            </div>
                          </>
                        ),
                      },
                    ],
                  }}
                  overlayClassName="singleDropdown"
                  className="singLock imageMargin"
                  placement="bottom"
                  open={false}
                >
                  <Space>
                    {/* <LockIcon /> */}
                    <FaStar
                      color="#A8A8A8"
                      style={{ ":hover": { color: "#c4c4c4" } }}
                    />
                  </Space>
                </Dropdown>
              )}
              <span>{record.title}</span>
            </Space>
          </NavLink>
        </>
      ),
      width: "45%",
    },
    {
      title: "Created On",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => a.created_at.localeCompare(b.created_at),
      sortDirections: ["descend", "ascend", "descend"],
      defaultSortOrder: "descend",
      render: (text, record) => <p>{formatDate(record.created_at)}</p>,
      align: "left",
      width: "15%",
    },
    {
      sorter: false,
      title: <span className="taskHead bg-red">nOT STARTED</span>,
      dataIndex: "notStarted",
      key: "notStarted",
      render: (text, record) => renderAttendeesColumn(record.notStarted),
      align: "center",
      width: "15%",
    },
    {
      sorter: false,
      title: <span className="taskHead bg-green">SUBMITTED</span>,
      dataIndex: "submitted",
      key: "submitted",
      render: (text, record) => renderAttendeesColumn(record.submitted),
      align: "center",
      width: "15%",
    },

    {
      sorter: false,
      title: "More",
      key: "action",
      align: "center",
      render: (text, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: uuidv4(),
                  label: (
                    <>
                      <NavLink
                        to={`/surveys/details/${record.id}`}
                        className={"black"}
                      >
                        <BinocularsLight />
                        View
                      </NavLink>
                    </>
                  ),
                },
                hasAccess(record?.user) && {
                  key: uuidv4(),
                  label: (
                    <>
                      <div
                        onClick={() => {
                          handleOpenEditForm(record);
                        }}
                      >
                        <EditIcon />
                        Edit
                      </div>
                    </>
                  ),
                },
                {
                  key: uuidv4(),
                  label: (
                    <>
                      <div
                        onClick={() => {
                          setSurveyShareData(record);
                          setShowModal((prevState) => ({
                            ...prevState,
                            shareModal: true,
                          }));
                        }}
                      >
                        <ShareIcon />
                        Share
                      </div>
                    </>
                  ),
                },
                hasAccess(record?.user) && {
                  key: uuidv4(),
                  label: (
                    <div
                      className={"deleteLabel"}
                      onClick={() => {
                        setSurveyIDForDelete(record.id);
                        handleSetSelectedData(record);
                        setShowModal((prevState) => ({
                          ...prevState,
                          deleteModal: true,
                        }));
                      }}
                    >
                      <RecycleBin />
                      Delete
                    </div>
                  ),
                },
              ],
            }}
            placement="bottomRight"
            trigger={["click"]}
            overlayClassName={"defaultDropdown"}
          >
            <div className="icon cursor-pointer">
              <MoreIcon />
            </div>
          </Dropdown>
        </Space>
      ),
      width: "10%",
    },
  ];
};

function renderAttendeesColumn(attendees) {
  if (!attendees) {
    return null;
  }

  const attendeeNames = attendees.attendents || [];
  const isAnonymous = attendees.isAnonymous;

  const attendeeTooltipContent = (
    <div className="attendeeNames">
      {isAnonymous ? (
        <span>Anonymous responses</span>
      ) : (
        <>
          {attendeeNames.slice(0, 7).map((name, index) => (
            <React.Fragment key={index}>
              <span>{name}</span>
              {index < attendeeNames.slice(0, 7).length - 1}
            </React.Fragment>
          ))}
          {attendeeNames.length > 7 && (
            <>
              <strong>+{attendeeNames.length - 7} more</strong>
            </>
          )}
        </>
      )}
    </div>
  );

  return (
    <div className="">
      {attendees.count != 0 ? (
        isAnonymous ? (
          <div className="seenBy dottedRoundedBox">
            <span>{attendees.count}</span>
          </div>
        ) : (
          <Tooltip
            title={attendeeTooltipContent}
            placement="bottom"
            overlayClassName="custom-tooltip"
            color="purple"
          >
            <div className="seenBy dottedRoundedBox">
              <span>{attendees.count}</span>
            </div>
          </Tooltip>
        )
      ) : (
        <div className="seenBy dottedRoundedBox">
          <span>{attendees.count}</span>
        </div>
      )}
    </div>
  );
}
